import { memo, useCallback, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BiArrowBack } from 'react-icons/bi';
import { MdOutlineYoutubeSearchedFor } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzHeading, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../../components';
import TabMutualFundContent from '../Search/TabMutualFundContent';
import { updateMutualFundWatchlist, getMutualFundSearch, createMutualFundProfile } from '../../../redux/actions/mutualFund';
import { handleModal } from "../../../redux/actions/modals";
import { GLOBAL_SEARCH_MIN_LENGTH } from '../../../utils/global_variables';
import { useDebounce } from '../../../hooks';


const searchHistory = [
    'Aditya Birla Sun Life Balanced Advantage Fund',
    'Kotak Balanced Advantage Fund'
];

const CreateCustomWatchListModal = ({ mutualFundsScrips, setMutualFundsScrips, mutualFund, newWatchlistName, setNewWatchlistName }) => {

    const dispatch = useDispatch();
    const [searchFund, setSearchFund] = useState('');
    const watchList = useSelector((state) => state.mutualFund.watchList);
    const modals = useSelector(state => state?.modals?.modals);
    const search = useSelector(state => state.mutualFund.search);

    const handleChange = useCallback((e) => {
        setSearchFund(e?.target?.value?.toUpperCase());
        const objPayload = {
            amcCode: "",
            schemeType: "",
            schemeCode: "",
            optCode: "",
            lstUpdtTime: "",
            schemeName: e.target.value?.toUpperCase(),
            txtSchemeCode: "",
            pageNo: "1",
            pageSize: "25"
        };
        if (e.target.value.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            useDebounce(() => {
                dispatch(getMutualFundSearch(objPayload));
            }, 1000);
        } else { }
    }, [dispatch]);

    const handleOnBack = () => {
        dispatch(handleModal([{ "CREATE_CUSTOM_WATCHLIST": false }, { "CREATE_WATCHLIST": true }]));
    };

    const handleClose = () => {
        dispatch(handleModal([{ "CREATE_CUSTOM_WATCHLIST": false }]));
        setSearchFund('');
    };
    const getProfileId = useCallback((profile) => {
        if (profile?.length > 0 || profile !== undefined) {
            return profile;
        } else {
            return -1;
        }
    }, []);

    const getProfileName = useCallback((profile_name) => {
        if (profile_name?.length > 0 || profile_name !== undefined) {
            return profile_name;
        } else {
            return newWatchlistName;
        }
    }, [newWatchlistName]);


    const getDefaultType = useCallback((default_type) => {
        if (default_type === 'Y' || default_type === "N") {
            return default_type;
        } else {
            return 'Y';
        }
    }, []);

    const getProfileType = useCallback((profile_name) => {
        if (profile_name > 0 || profile_name !== undefined) {
            return 'R';
        } else {
            return 'A';
        }
    }, []);

    const OnSubmit = useCallback(() => {
        const arrSchemes = mutualFundsScrips?.map((eachFund) => ({
            exchange_code: eachFund.exchange_code,
            scheme_code: eachFund.scheme_code
        }));
        let mutualFundProfile = watchList.mutualFundProfile;
        const payload = { data: [...mutualFundsScrips], name: mutualFundProfile.profile_name, mutualFundProfile: watchList.mutualFundProfile };
        const objcreateProfilePayload = {
            profile_id: getProfileId(mutualFundProfile.profile_id),
            profile_name: getProfileName(mutualFundProfile.profile_name),
            default_type: getDefaultType(mutualFundProfile.is_default),
            update_type: getProfileType(mutualFundProfile.profile_name),
            scheme_list: arrSchemes
        };
        dispatch(createMutualFundProfile(objcreateProfilePayload));
        dispatch(updateMutualFundWatchlist(payload));
        dispatch(handleModal([{ "CREATE_CUSTOM_WATCHLIST": false }, { "CREATE_WATCHLIST": false }]));
        setSearchFund('');
    }, [watchList, getProfileName, dispatch, mutualFundsScrips]);



    return (
        <BzModal size='lg' show={modals['CREATE_CUSTOM_WATCHLIST']} onHide={handleClose} className='p-3'>
            <BzModalHeader>
                <Container>

                    <Row className='g-0 global-search-header p-3'>
                        <Col md={1}>
                            <BiArrowBack size={20} onClick={handleOnBack}></BiArrowBack>
                        </Col>
                        <Col md={9} className='d-flex justify-content-start'>
                            <BzInputText size='sm' className='font-regular font-size4 color-text bdr-none p-0' placeholder='Search for mutual funds...' onChange={handleChange} value={searchFund} />
                        </Col>
                        <Col md={1}>
                            {searchFund && <span className='font-medium color-text' onClick={() => {
                                setSearchFund('');
                            }}>Clear</span>}
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div onClick={handleClose} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-close icon-dark ms-3'></div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container>
                    <div className='d-flex  top-stocks mb-4 ' >
                        <div className='w-100'>
                            {searchFund ?
                                <TabMutualFundContent mutualFund={mutualFund} searchValue={searchFund} isShowing={modals['CREATE_CUSTOM_WATCHLIST']} searchData={search} mutualFundsScrips={mutualFundsScrips}
                                    setMutualFundsScrips={setMutualFundsScrips} />
                                :
                                <>
                                    <div>RECENTLY SEARCHED</div>
                                    {searchHistory?.map((search, i) =>
                                        <div key={i} className='m-4 d-flex justify-content-start'>
                                            <MdOutlineYoutubeSearchedFor size={24} />
                                            <span className='mx-2 font-medium'>{search}</span>
                                        </div>
                                    )}
                                </>
                            }
                        </div>

                    </div>
                </Container>
            </BzModalBody>

            {searchFund ?
                <>
                    <Row className='g-0'>
                        <Col>
                            <div className='fancyline'></div>
                        </Col>
                    </Row>
                    <BzModalFooter>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={10} className='d-flex justify-content-start align-items-center'>
                                    <span className='font-regular font-size4 color-subtext'>{`Add ${watchList?.data?.length ? 'To' : 'New'} Watchlist`}</span>
                                    <BzHeading className='font-medium font-size4 color-text ps-2'>{watchList?.name}</BzHeading>
                                    <div className='number-badge ms-2'>{mutualFundsScrips?.length} </div>
                                </Col>
                                <Col md={2} className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-primary btn-md text-uppercase' onClick={OnSubmit}>Done</BzButton>
                                </Col>
                            </Row>
                        </Container>

                    </BzModalFooter>
                </> :
                null}

        </BzModal>
    );
};

export default memo(CreateCustomWatchListModal);